// Espelha worker/src/lib/hotmartSaleStatusLabels.mjs — duplicado de
// propósito (frontend e Worker são dois projetos npm publicados
// separadamente, sem um pacote compartilhado entre os dois) só para
// popular o filtro de status. A fonte da verdade sobre QUAL rótulo cada
// venda mostra continua sendo o Worker (SaleRow.statusLabel, já vem
// pronto na resposta da API) — isto aqui é usado só para as opções do
// <select> de filtro.
export const STATUS_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: 'Todos os status' },
  { value: 'approved', label: 'Aprovada' },
  { value: 'complete', label: 'Completa' },
  { value: 'refunded', label: 'Reembolsada' },
  { value: 'partially_refunded', label: 'Reembolso parcial' },
  { value: 'canceled', label: 'Cancelada' },
  { value: 'chargeback', label: 'Chargeback' },
  { value: 'expired', label: 'Expirada' },
  { value: 'waiting_payment', label: 'Aguardando pagamento' },
  { value: 'blocked', label: 'Bloqueada' },
  { value: 'billet_printed', label: 'Boleto impresso' },
  { value: 'processing', label: 'Processando' },
  { value: 'dispute', label: 'Em disputa' },
  { value: 'other', label: 'Outro' },
];

// Usado só pelos dados fictícios do modo de demonstração (demoData.ts) —
// em produção o rótulo sempre vem pronto do Worker (SaleRow.statusLabel).
export function labelForStatus(status: string): string {
  return STATUS_FILTER_OPTIONS.find((option) => option.value === status)?.label ?? status;
}

// Espelha REVENUE_COUNTING_STATUSES de
// worker/src/lib/hotmartSaleStatusLabels.mjs — as únicas vendas que geram
// comissão de verdade. Usado pelo filtro "Ocultar canceladas" da listagem
// de vendas (SalesFilterBar/SalesTable): reembolsada, reembolso parcial,
// cancelada, chargeback, em disputa e qualquer outro status fora deste
// conjunto nunca geram comissão, então "ocultar canceladas" oculta tudo
// que não estiver aqui dentro.
export const COMMISSION_GENERATING_STATUSES = new Set(['approved', 'complete']);
